import Vue from 'vue'
import Router from 'vue-router'
import InfoApp from '@/components/InfoApp'
import AddMushRoom from '@/components/AddMushRoom'
import OwnMushRoom from '@/components/OwnMushRoom'
import AllMushRoom from '@/components/AllMushRoom'
import EditMushRoom from '@/components/EditMushRoom'
import SendMushRoom from '@/components/SendMushRoom'
import ConfirmAndAlert from '../components/ConfirmAndAlert'
import AlertToUser from '../components/AlertToUser'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'InfoApp',
      component: InfoApp
    },
    {
      path: '/addmushroom',
      component: AddMushRoom
    },
    {
      path: '/ownmushroom',
      component: OwnMushRoom
    },
    {
      path: '/allmushroom',
      component: AllMushRoom
    },
    {
      path: '/editmushroom/:id',
      component: EditMushRoom
    },
    {
      path: '/sendmushroom',
      component: SendMushRoom
    },
    {
      path: '/confirmandalert',
      component: ConfirmAndAlert
    },
    {
      path: '/alerttouser/:analysisid',
      component: AlertToUser
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js